import { Injectable } from "@angular/core";
import {
	MatLegacySnackBar as MatSnackBar,
	MatLegacySnackBarRef as MatSnackBarRef,
} from "@angular/material/legacy-snack-bar";
import { Store } from "@ngrx/store";
import { Message, MessageAction, MessageFilter, MessageSelector } from "@obg/ngx.core";
import { CoreContentState, MessageCodeFallbackService, TranslationService } from "@obg/ngx.core.content";
import { LoggingService } from "@obg/ngx.global.evo";
import { MessageDisplayService } from "@obg/ngx.ui.core";
import { cloneDeep } from "lodash-es";
import { Observable } from "rxjs";

import { SnackBarComponent } from "../snackbar/snackbar.component";

import { MessageSnackBarConfigService } from "./message-snackbar.config";
import { MessageSnackBarOptions } from "./message-snackbar.model";

@Injectable()
export class MessageSnackBarService extends MessageDisplayService<MatSnackBarRef<SnackBarComponent>> {
	constructor(
		messageAction: MessageAction,
		messageCodeFallbackService: MessageCodeFallbackService,
		messageSelector: MessageSelector,
		store: Store<CoreContentState>,
		translationService: TranslationService,
		loggingService: LoggingService,
		private snackBar: MatSnackBar,
		private config: MessageSnackBarConfigService
	) {
		super(messageAction, messageCodeFallbackService, messageSelector, store, translationService, loggingService);
	}

	present(message: Message | Message[], options: MessageSnackBarOptions): MatSnackBarRef<SnackBarComponent> {
		const buttons = cloneDeep(options.buttons);
		if (!options.doNotTranslate) {
			if (buttons) {
				for (const button of buttons) {
					if (button.text) {
						button.text = super.getTranslationInstant(super.getMessageKey(undefined, button.text));
					}
				}
			}
		}

		const type = super.getMessageType(message);
		let panelClass = type ? [type.toString()] : [];

		if (options.panelClass) {
			panelClass = [...options.panelClass, ...panelClass];
		}

		return this.snackBar.openFromComponent(SnackBarComponent, {
			duration: this.config.getDurationInMillis(),
			panelClass,
			verticalPosition: options.verticalPosition || "top",
			data: {
				...options,
				message: super.getMessageText(message, options),
				buttons,
			},
		});
	}

	presentOnDispatch(
		filter: MessageFilter,
		options?: MessageSnackBarOptions
	): Observable<MatSnackBarRef<SnackBarComponent>> {
		return super.presentOnDispatch(filter, options);
	}
}
